import React, { useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import Select from "react-select";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ChangeSaved from "../../popups/ChangeSaved";
import ErrorPopup from "../../popups/ErrorPopup";
import { useParams } from "react-router-dom";
import {
  updateDoctorType,
  updatePharmacyType,
} from "../../../redux/actions/customerActions";
import { useDispatch } from "react-redux";

const PharmacyTypeModal = ({ show, handleClose, code, name }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    handleClose();
  };

  const initialValues = {
    pharmacy_id: params?.id,
    pharmacy_type: "",
  };
  const validationSchema = Yup.object().shape({
    pharmacy_id: Yup.string().required("Required"),
  });
  const onSubmit = (values) => {
    console.log(values, "value");
    dispatch(updatePharmacyType(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);
    handleClose();
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    handleClose();
  };

  const customerTypeList = [
    { label: "Dispensing", value: "dispensing" },
    { label: "Attach", value: "attach" },
  ];
  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName=""
        contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
      >
        <ModalBody>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {({ setFieldValue, values }) => (
              <Form className="p-1">
                <p className="fn_Nunito fw_700 fs_18 my-2 px-0">
                  Change Pharmacy Type
                </p>
                <div className="my-4">
                  <label className="Neutral_Color fs_14">Pharmacy Code</label>
                  <p className="fs_14"> {code}</p>
                </div>

                <div className="my-4">
                  <label className="Neutral_Color fs_14">Pharmacy Name</label>
                  <p className="fs_14">Dr. {name}</p>
                </div>

                <div className="my-4">
                  <label className="fs_14">Pharmacy Type</label>
                  <Field>
                    {({ form, Field }) => (
                      <Select
                        options={customerTypeList}
                        styles={customStyles}
                        {...Field}
                        id="pharmacy_type"
                        name="pharmacy_type"
                        placeholder="Select Doctor type"
                        onChange={(selectedOption) => {
                          form.setFieldValue(
                            "pharmacy_type",
                            selectedOption.value
                          );
                        }}
                      />
                    )}
                  </Field>
                </div>

                <div className="d-flex justify-content-end align-items-center gap-3">
                  <button
                    type="button"
                    onClick={() => handleClose()}
                    className="modal-logout-btn fs_14 fw_700 px-4 py-2"
                    style={{ width: "130px" }}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="modal-cancel-btn fs_14 text-white py-2 px-4 fw_700"
                    style={{ width: "130px" }}
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default PharmacyTypeModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
